import { z } from 'zod';
import { dateLike } from '@/schemas/field-schemas';

export const searchSchema = z.object({
  // Main fields
  ngay_h_toan_tu: dateLike,
  ngay_h_toan_den: dateLike,
  duoc_thanh_toan_de: dateLike,
  ngay_tat_toan: dateLike,

  // Detail tab fields
  tat_toan: z.string().optional(),
  mau_bao_cao: z.string().optional(),
  // Other tab fields
  so_c_tu_tu: z.string().optional(),
  so_c_tu_den: z.string().optional(),
  mau_loc_bao_cao: z.string().optional()
});

export const initialValues = {
  // Main fields
  ngay_h_toan_tu: '',
  ngay_h_toan_den: '',
  duoc_thanh_toan_de: '',
  ngay_tat_toan: '',

  // Detail tab fields
  tat_toan: '0',
  mau_bao_cao: '0',

  // Other tab fields
  so_c_tu_tu: '',
  so_c_tu_den: '',
  mau_loc_bao_cao: '0'
};
